import { useAxiosModule } from '@/modules/_shared/axios'
import { AuditLog, AuditLogsResponse } from './types'
import { AuditLogsSearchFilter } from '@/views/_shared/search-list/types'

const { getFromApi } = useAxiosModule()

/* Get Audit logs list */

export type GetAuditLogsResponse = AuditLogsResponse
export async function getAuditLogsList (search = {} as AuditLogsSearchFilter, sortBy = 'id desc', limit = 0, offset = 0) {
    const queryParams = new URLSearchParams()
    queryParams.set('search', search.search)
    queryParams.set('id', search.id)
    queryParams.set('operatorName', search.operatorName)
    queryParams.set('operatorOrigin', search.operatorOrigin)
    queryParams.set('action', search.action)
    queryParams.set('requestId', search.requestId)
    queryParams.set('occurrence', search.occurrence)
    queryParams.set('sort', sortBy)
    queryParams.set('limit', String(limit))
    queryParams.set('offset', String(offset))
    const url = 'audit-log?' + queryParams.toString()
    return getFromApi<GetAuditLogsResponse>(url)
}

/* Get audit log */

export type GetAuditLogResponse = AuditLog
export async function getAuditLog (id: string) {
    return getFromApi<GetAuditLogResponse>(`audit-log/${id}`)
}
